
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Icons / download","xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Combined Shape","d":"M5.413 22A5.413 5.413 0 010 16.587a.943.943 0 111.885 0A3.527 3.527 0 005.2 20.108l.215.007h11.172a3.527 3.527 0 003.528-3.528.943.943 0 111.885 0 5.413 5.413 0 01-5.151 5.406l-.262.007zm4.907-6.995l-4.457-4.456A.942.942 0 017.09 9.125l.105.09 2.863 2.863V.942a.943.943 0 011.876-.128l.008.128v11.134L14.8 9.215a.944.944 0 011.227-.09l.106.09a.944.944 0 01.092 1.228l-.092.105-4.467 4.472a.942.942 0 01-.2.151l-.018.01-.014.007h-.008l-.01.005-.013.006h-.006a.943.943 0 01-1.075-.2z","fill":"current-color"}})])
          )
        }
      }
    